import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import PropTypes from "prop-types";

const COLOR_CSS = "black";

const css = {
  root: {
    position: "fixed",
    left: 0,
    top: 0,
    width: "100dvw",
    height: "100dvh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",

    backgroundColor: "#ffffff",
    opacity: 0.8,
    zIndex: 2000
  },
  opaqueBackground: { opacity: 1 },
  wrapper: {
    width: "100%",
    display: "flex",
    justifyContent: "center"
  }
};

FullScreenLoadingView.propTypes = {
  sizePX: PropTypes.number,
  useOpaqueBackground: PropTypes.bool
};

FullScreenLoadingView.defaultProps = {
  sizePX: 40,
  useOpaqueBackground: false
};

function FullScreenLoadingView(props) {
  const { sizePX, useOpaqueBackground } = props;

  return (
    <div
      style={{
        ...css.root,
        ...(useOpaqueBackground ? css.opaqueBackground : {})
      }}
    >
      <div style={css.wrapper}>
        <CircularProgress
          style={{ color: COLOR_CSS, width: sizePX, height: sizePX }}
        />
      </div>
    </div>
  );
}

export default FullScreenLoadingView;
